import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';

import { Viewer, Entity } from 'resium';

import { initSocketConnection } from "../socket";
import { loadPoints } from "./cesium";

const WS_URL = process.env.REACT_APP_HOST || 'localhost:5000';

const initLiveFeed = (cb) => {
    initSocketConnection(WS_URL, (dataToLoad) => {
        console.log('-------\n-------\n-------\n');
        console.log('dataToLoad:', dataToLoad);
        const newData = loadPoints([dataToLoad], true, false, true);
        console.log('after loadPoints:', newData);
        cb(newData);
    });
}

export default function Live() {
    const viewerRef = useRef(null);
    const [modelEntities, setModelEntities] = useState([]);
    const [entities, setEntities] = useState([]);

    useEffect(() => {
        initLiveFeed((newData) => {
            console.log('setting viewerData', newData);
            // setViewerData(newData);
            
            const newModelEntities = [];
            const newEntities = [];
            for (const dataSet of newData || []) {
                
                for (const track of dataSet || []) {
                    if (track) {
                        const { entities, modelEntity, mainStart, mainStop, startTime, stopTime } = track;
                        
                        if (modelEntity) {
                            newModelEntities.push(modelEntity);  
                        }
                        if (entities?.length) {
                            newEntities.push(...entities);              
                        }
                    }
                }
            }

            setModelEntities(newModelEntities);
            setEntities(newEntities);
        });
    }
    , []);

    const hideLegendBox = true;
    const legendBoxElem = hideLegendBox ? (<></>) : (
        <Box
                id='legend-box'
                sx={{
                    zIndex: 1000,
                    position: 'fixed',
                    right: 5,
                    bottom: 5,
                    width: 190,
                    height: 'auto',
                    padding: 2,
                    paddingY: 1,
                    backgroundColor: '#282c34',
                    color: 'white',
                    border: '1px solid grey',
                    display: 'flex'
                }}
            >
                <Box>
                    <Typography textAlign='left' variant='body1'><span style={{ fontSize: '1.5rem', color: 'ORANGE' }}>ADS-B</span><span>&nbsp;</span></Typography>
                    <Typography textAlign='left' variant='body1'><span style={{ fontSize: '1.5rem', color: 'PLUM' }}>UAS/5G</span><span>&nbsp;</span></Typography>
                    <Typography textAlign='left' variant='body1'><span style={{ fontSize: '1.5rem', color: 'LIME' }}>Validated</span><span>&nbsp;</span></Typography>
                    <Typography textAlign='left' variant='body1'><span style={{ fontSize: '1.5rem', color: 'YELLOW' }}>Spoofed</span><span>&nbsp;</span></Typography>
                    <Typography textAlign='left' variant='body1'><span style={{ fontSize: '1.5rem', color: 'RED' }}>Denied</span><span>&nbsp;</span></Typography>
                </Box>
                <Box>
                    <Typography variant='body1'><span style={{ fontSize: '1.5rem', color: 'ORANGE' }}>GPS</span></Typography>
                    <Typography variant='body1'><span style={{ fontSize: '1.5rem', color: 'PLUM' }}>GPS</span></Typography>
                    <Typography variant='body1'><span style={{ fontSize: '1.5rem', color: 'LIME' }}>GPS</span></Typography>
                    <Typography variant='body1'><span style={{ fontSize: '1.5rem', color: 'YELLOW' }}>GPS</span></Typography>
                    <Typography variant='body1'><span style={{ fontSize: '1.5rem', color: 'RED' }}>GPS</span></Typography>
                </Box>
                {/* <Typography variant='body2'>Other track points: <span style={{ color: 'GREEN' }}>Green</span></Typography> */}
            </Box>
    );

    return (
        <Grid id='live-grid' container spacing={3}>
            <Typography sx={{
                zIndex: 1000,
                position: 'fixed',
                top: '10px',
                left: '60px',
                color: 'white',
                fontStyle: 'italic',
                fontWeight: '800',
                fontSize: {
                    sx: '1rem',
                    sm: '3vw',
                    md: '3vw',
                    lg: '3vw',
                    xl: '3vw'
                }
            }}>
                GPS VALIDATION / GPS-DENIED SOLUTIONS
            </Typography>
            <Box
                id='legend-box'
                sx={{
                    zIndex: 1000,
                    position: 'fixed',
                    left: 0,
                    bottom: -8,
                    width: 200,
                    height: 'auto',
                }}
            >
                <img src='SeamticaLogoWhite.png' alt='Seamatica Logo' width={'300vw'}/>
            </Box>
            {legendBoxElem}
            <Viewer full animation={false} timeline={false} shadows={false} shouldAnimate={false}>
                {
                    modelEntities.map((modelEntity, i) => {
                        return (
                            <Entity
                                key={modelEntity.id}
                                {...modelEntity}
                            />
                        );
                    })
                }
                {
                    entities.map((entity, i) => {
                        return (
                            <Entity
                                key={entity.id}
                                {...entity}
                            />
                        );
                    })
                }
            </Viewer>
        </Grid>
    );
}